export default __webpack_public_path__ + "static/media/refact.c391ec10.png";